// Display Settings → Home Screen — sub-page route.
// -----------------------------------------------------------------
// TanStack Router flat-file convention: the trailing underscore in
// `display-settings_` opts this route OUT of nesting under the
// `display-settings.tsx` layout component, so <DisplaySettingsPage>
// mounts directly without needing an <Outlet /> in the parent.
// URL: /display-settings/home-screen.  Route id:
// /_authenticated/display-settings_/home-screen.
//
// Mirrors the `tour-planner_.$planId.tsx` pattern (M4.1-P1).

import { Navigate, createFileRoute } from '@tanstack/react-router';

import { DisplaySettingsPage } from '@/components/display-settings/DisplaySettingsPage';
import { isFeatureEnabled } from '@/lib/featureFlags';

const HomeScreenRoute = () => {
  if (!isFeatureEnabled('DISPLAY_SETTINGS')) {
    return <Navigate to='/hello' replace />;
  }
  return <DisplaySettingsPage activeSection='home-screen' />;
};

export const Route = createFileRoute(
  '/_authenticated/display-settings_/home-screen',
)({
  component: HomeScreenRoute,
});
